import React, { useState } from 'react';
import { SearchIcon } from '../../../assets/icons';
import Card from '../../../components/Card';
import Spinner from '../../../components/Spinner';
import TextInput from '../../../components/TextInput';
import useTradePools from '../../../hooks/web3/trade/useTradePools';
import ExchangeMarketListRow from './ExchangeMarketListRow';
import useChartState from '../../../context/chart/useChartState';

const ExchangeMarketList = () => {
    const { tradePools, isLoading } = useTradePools();

    const [search, setSearch] = useState('');

    const { favouriteMarkets, toggleFavouriteMarket } = useChartState();

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        if (value.match(/^[A-Za-z]+$/) || !value) {
            setSearch(value);
        }
    };

    return (
        <Card className='exchange-market-lists'>
            <div className='input-container' onClick={(e) => e.stopPropagation()}>
                <SearchIcon />
                <TextInput
                    variant='text'
                    name='market-option'
                    value={search}
                    onChange={handleSearch}
                    placeholder='Search markets'
                    pattern='[A-Za-z]{3}'
                />
            </div>
            <div className='market-list'>
                <div className='header'>
                    <span>Market</span>
                    <span className='price'>Price</span>
                    <span className='change'>Change</span>
                </div>
                {isLoading ? (
                    <div className='loading-container'>
                        <Spinner />
                        <span>Loading Market List...</span>
                    </div>
                ) : (
                    <ul className='market-list-body'>
                        {tradePools && tradePools.length
                            ? tradePools
                                  .map((pool) => ({
                                      ...pool,
                                      isFavourited: favouriteMarkets.includes(pool.name),
                                  }))
                                  .filter(({ name }) =>
                                      name.toLowerCase().includes(search.toLowerCase())
                                  )
                                  .sort(
                                      // sorts by favourite then, sorts by name
                                      (a, b) =>
                                          (a.isFavourited === b.isFavourited
                                              ? 0
                                              : a.isFavourited
                                              ? -1
                                              : 1) || a.name.localeCompare(b.name)
                                  )
                                  .map((pool) => (
                                      <ExchangeMarketListRow
                                          key={pool.name}
                                          pool={pool}
                                          toggleFavourite={toggleFavouriteMarket}
                                      />
                                  ))
                            : 'We had trouble loading market data'}
                    </ul>
                )}
            </div>
        </Card>
    );
};

export default ExchangeMarketList;
